var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputBorderUnselected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234,
    height: 54,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1,
    y1: 0.747,
    x2: -0.013,
    y2: 0.139,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#fff",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Field 2 unselected",
    d: "M234 54H0V0h234v54zM.962 1.35v51.3h232.076V1.35z",
    style: {
      opacity: 0.8,
      fill: "url(#a)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputBorderUnselected);
export default __webpack_public_path__ + "static/media/input-border-unselected.101ebee42cfa03a10ba5b45e4adeacd9.svg";
export { ForwardRef as ReactComponent };